import React, { Component } from 'react';
import SERVER_URL from '../Global';
import { Breadcrumb, Icon, Spin, Avatar } from 'antd';
import queryString from 'query-string';
import { Container, Row, Col } from 'reactstrap';
import { Select, Tabs, AutoComplete, Input, Popover, Button, Switch, Modal, Radio, Badge } from 'antd';
import CardDetailed from '../util/compCardDetailed';
import CardLite from '../util/compCardLite';

const { Option } = Select;
const { TabPane } = Tabs;
const antIcon = <Icon type="loading" style={{ fontSize: 114 }} spin />;

export class HomeList extends Component {
    static displayName = HomeList.name;
    constructor(props) {
        super(props);
        let params = queryString.parse(this.props.location.search);
        this.state = {
            user: this.props.token,
            language: "en",
            companies: [],
            loading: true,
            top: 10,
            orderBy: params.orderBy,
            order: params.order,
            searchName: null,
            categories: [],
            tipologies: [],
            hasPhone: [],
            hasWebsite: [],
            hasMail: [],
            hasAddress: [],
            companyCategoryName: '',
            imageComp: true,
            iniziale: null,
            alfabeto: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', '#'],
            page: 2,
            companyTypology: '',
            hasFiltersOn: false,
            compHidden: false,
            inDesignXML: '',
            inDesignXMLIndex: '',
            loadingXML: false,
            loadingXMLIndex: false,
            bookmarks: localStorage.getItem("bookmarked"),
            bookmarked: true,
            showOnlyBookmarked: false,
            searchCompanyName: '',
            companyDetail: [],
            hasDetail: false,
            detailIsLink: false,
            fakeMap: ['1'],
            status: [5, 1, 0, 4, 3],
            loadingDetail: false,
            pageSize: 24,
            pageNumber: 1,
            maxPageSize: 1,
            loadingBelow: false,
            TypologyName: "",
            hrFullName: '',
            ExcludeTypologyName: "Department",
            catLoad: true,
            citiesArray: [],
            zipCodesArray: [],
            compLoad: true,
            zipCodeId: null,
            cityId: null,
            modalDelete: false,
            compDeleted: false,
            collapsed: this.props.collapsed,
            compDisabled: false,
            isDeleted: null,
            filterMenuVisible: false,
            hasCounterOn: false,
            totalItems: null,
            totalCompanies: '',
            totalBrands: '',
            totalSigns: '',
            totalDepartments: '',
            categoriesSelected: [0],
            catId: 0
        };

        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleCat = this.handleCat.bind(this);
        this.callback = this.callback.bind(this);
        this.searchCompany = this.searchCompany.bind(this);
        this.handleTyp = this.handleTyp.bind(this);
        this.handleHidden = this.handleHidden.bind(this);
        this.handleFilters = this.handleFilters.bind(this);
        this.copyToClipboard = this.copyToClipboard.bind(this);
        this.copyToClipboardIndex = this.copyToClipboardIndex.bind(this);
        this.exportInDesign = this.exportInDesign.bind(this);
        this.exportInDesignIndex = this.exportInDesignIndex.bind(this);
        this.changeLanguage = this.changeLanguage.bind(this);
        this.handleBookmark = this.handleBookmark.bind(this);
        this.getDetail = this.getDetail.bind(this);
        this.handleSizeChange = this.handleSizeChange.bind(this);
        this.handleHrFullname = this.handleHrFullname.bind(this);
        this.reloadCompanies = this.reloadCompanies.bind(this);
        this.crossFetch = this.crossFetch.bind(this);
        this.changeFocus = this.changeFocus.bind(this);
        this.clearFilters = this.clearFilters.bind(this);

        this.searchZipCodes = this.searchZipCodes.bind(this);
        this.handleZipCode = this.handleZipCode.bind(this);
        this.searchCities = this.searchCities.bind(this);
        this.handleCities = this.handleCities.bind(this);
        this.deleteAddressResult = this.deleteAddressResult.bind(this);
        this.handleResult = this.handleResult.bind(this);
        this.clearResult = this.clearResult.bind(this);
        this.handleDeleted = this.handleDeleted.bind(this);
        this.handleDisabled = this.handleDisabled.bind(this);
        this.hide = this.hide.bind(this);
        this.clearResultZip = this.clearResultZip.bind(this);
        this.clearResultCity = this.clearResultCity.bind(this);
        this.fetchCat = this.fetchCat.bind(this);
        this.refreshCatSearch = this.refreshCatSearch.bind(this);
        this.getCount = this.getCount.bind(this);

        document.title = "Polar - Companies"
    }

    componentDidMount() {
        //parte al caricamento del componente        
        if (this.state.user.length > 10) {
            fetch(
                `${SERVER_URL + 'api/company/list?lang=en'}`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${this.state.user}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    "companyname": this.state.searchName,
                    "companyCatIdList": [],
                    "ExcludeTypologyName": "Department",
                    "HrNameSurname": this.state.hrFullName,
                    "page": 1,
                    "companyStatusList": this.state.status,
                    "PageSize": this.state.pageSize,
                    "ordering": {
                        "orderPropertyName": this.state.orderBy,
                        "order": this.state.order
                    }
                })
            }
            ).then(response => response.json())
                .then(res => {
                    if (res.data) {
                        this.setState({
                            companies: res.data, pageNumber: 1, maxPageSize: res.params.totalPages, loading: false, compLoad: false
                        });

                    }
                    else {
                        this.setState({ totalItems: 0, loading: false, companies: [] });
                    }

                    if (this.state.order === undefined) {
                        this.setState({ order: '1' });
                    }

                    if (this.state.orderBy === undefined) {
                        this.setState({ orderBy: 'companyname' });
                    }

                    if (this.state.searchName === undefined) {
                        this.setState({ searchName: ' ' });
                    }
                })

            //tipologie
            fetch(
                `${SERVER_URL + 'api/translation/list?lang=en'}`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${this.state.user}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    "typeTip": "CompanyTypology",
                    "page": 1,
                    "PageSize": 40,
                    "ordering": {
                        "orderPropertyName": 'name',
                        "order": 1
                    },
                })
            }
            ).then(response => response.json())
                .then(res => {
                    if (res.data != null) {
                        this.setState({ tipologies: res.data, loading: false });
                    } else {
                        this.setState({ tipologies: [], loading: false });
                    }
                })
            this.fetchCat()
        }
        window.addEventListener('resize', this.updateDimensions);
    }

    updateDimensions = () => {
        window.location.href = window.location.href
    };

    fetchCat() {
        //categorie
        fetch(
            `${SERVER_URL + 'api/companycategory/list'}`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${this.state.user}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                "name": '',
                "page": 1,
                "PageSize": 88,
                "ordering": {
                    "orderPropertyName": 'catName',
                    "order": 1
                }
            })
        }
        ).then(response => response.json())
            .then(res => {
                if (res.data != null) {
                    let categories = []
                    res.data.sort(function (a, b) {
                        if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
                        if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
                        return 0;
                    }).map(cat => {
                        if (cat.companyCategoryParentCatId == null) {
                            categories.push(cat)
                            res.data.map(son => {
                                if (son.companyCategoryParentCatId == cat.catId) {
                                    categories.push(son)
                                }
                            })
                        }
                    })

                    this.setState({ categories: categories, loading: false, catLoad: false });
                } else {
                    this.setState({ categories: [], loading: false, catLoad: false });
                }
            })
    }

    refreshCatSearch() {
        this.setState({ searchName: null })
        this.fetchCat()
    }

    componentDidUpdate(prevProps) {
        // parte il check quando
        if (this.props.collapsed !== prevProps.collapsed) {
            this.setState({ collapsed: this.props.collapsed });
        }
    }

    crossFetch() {
        //la funzione che parte ad ogni nuova ricerca, o i filtri

        var bookmarked = []

        if (this.state.showOnlyBookmarked === true) {
            if (localStorage.getItem("bookmarked") === null) {
                localStorage.setItem("bookmarked", [])
            }

            if (localStorage.getItem("bookmarked").indexOf(",") > -1) {
                bookmarked = JSON.parse("[" + localStorage.getItem("bookmarked") + "]")
            }
            else if (localStorage.getItem("bookmarked") > 0) {
                bookmarked = JSON.parse("[" + localStorage.getItem("bookmarked") + "]")
            }
            else {
                bookmarked = []
            }
        }
        else {
            bookmarked = []
        }

        console.log(this.state.iniziale == null ? null : "[" + this.state.iniziale + "]%")

        this.setState({ loading: true, inDesignXML: '', inDesignXMLIndex: '', });
        fetch(
            `${SERVER_URL + 'api/company/list?lang=en'}`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${this.state.user}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                "companyCatIdList": this.state.categoryId,
                "CompanyNameStartWith": this.state.iniziale == null ? null : "[" + this.state.iniziale + "]%",
                "CompanyName": `${this.state.searchCompanyName}`,
                "TypologyName": `${this.state.TypologyName}`,
                "ExcludeTypologyName": this.state.ExcludeTypologyName,
                "companyStatusList": this.state.status,
                "companyIdList": bookmarked,
                "isDeleted": this.state.isDeleted,
                "includeSoftDeleted": this.state.isDeleted,
                "HrNameSurname": this.state.hrFullName,
                "page": 1,
                "CityId": this.state.cityId,
                "ZipCodeId": this.state.zipCodeId,
                "PageSize": this.state.pageSize,
                "ordering": {
                    "orderPropertyName": this.state.orderBy,
                    "order": this.state.order
                }
            })
        }
        ).then(response => response.json())
            .then(res => {
                if (res.data != null) {
                    this.setState({
                        compLoad: false, totalItems: null, companies: res.data,
                        pageNumber: 1, maxPageSize: res.params.totalPages,
                        loading: false, page: 1, firstLoading: false,
                        visible: false, loadingDetail: false, modalDelete: false
                    });

                }
                else {
                    this.setState({
                        loading: false, companies: [], visible: false, loadingDetail: false, modalDelete: false
                    });
                }

                if (this.state.order === undefined) {
                    this.setState({ order: '1' });
                }

                if (this.state.orderBy === undefined) {
                    this.setState({ orderBy: 'companyname' });
                }

                if (this.state.searchName === undefined) {
                    this.setState({ searchName: ' ' });
                }
            })
    }

    callback(key) {
        //funzione che parte al click di una delle lettere sopra
        document.getElementById("scrollableInner").scrollTop = 0;
        if (key === 'all') { key = null }
        if (key === '#') { key = "0123456789" }

        this.setState({ iniziale: key, loading: true }, () => { this.crossFetch() })
    }

    changeFocus(event) {
        //parte al press di una freccia sulla tastiera, se c'è un dettaglio aperto, e cambia il dettaglio
        if (event.key === "ArrowLeft" && this.state.loadingDetail && this.state.previousDetail != 'undefined') {
            this.getDetail(this.state.previousDetail, false);
        } else if (event.key === "ArrowRight" && this.state.loadingDetail && this.state.nextDetail != 'undefined') {
            this.getDetail(this.state.nextDetail, false);
        }
    }

    closeDetail() {
        this.setState({ loadingDetail: false });
    }

    handleSizeChange(e) {
        this.setState({ pageSize: e.target.value, loading: true }, () => { this.crossFetch() });
    }

    //addresses
    handleZipCode(value) {
        var zipCodeId = value.substr(0, value.indexOf('/'));
        var CityId = value.substring(value.indexOf('/') + 1, value.indexOf('$'));
        var result = value.substr(value.indexOf('$') + 1);
        this.setState({ searchCity: true, zipResult: result, zipCodeId: zipCodeId, cityId: CityId });
        this.clearResultCity()
    }

    handleCities(value) {
        var zipCodeId = value.substr(0, value.indexOf('/'));
        var CityId = value.substring(value.indexOf('/') + 1, value.indexOf('$'));
        var result = value.substr(value.indexOf(',') + 2);
        this.setState({ searchZip: true, cityResult: result, zipCodeId: zipCodeId, cityId: CityId });
        this.clearResultZip()
    }

    searchZipCodes(value) {
        this.setState({ zipResult: value })
        if (value.length >= 3 || value.length === 0) {
            //cerca le città partendo dallo zip code
            fetch(
                `${SERVER_URL + 'api/zipCode/list'}`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${this.state.user}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    "value": value,
                    "page": 1,
                    "totalPages": 0,
                    "totalItems": 0,
                    "pageSize": 10,
                    "pageSizeOptions": null,
                    "firstItemNumber": 0,
                    "lastItemNumber": 0,
                    "ordering": {
                        "order": -1
                    },
                    "entityId": 0
                })
            }
            ).then(response => response.json())
                .then(res => {
                    if (res.data != null) {
                        let zipCodesArray = []
                        res.data.map(obj => {
                            obj.brCityZipCodes.map(city =>
                                zipCodesArray.push({ city: city, obj: obj })
                            )
                        })

                        this.setState({ zipCodesArray: zipCodesArray });
                    }
                })
            if (value.length == 0) {
                this.setState({ searchCity: false });
            }
        }
    }

    handleResult() {
    }

    getCount() {
        fetch(
            `${SERVER_URL + 'api/company/count'}`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${this.state.user}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                "companyCatIdList": this.state.categoryId,
                "CompanyNameStartWith": this.state.iniziale == null ? null : "[" + this.state.iniziale + "]%",
                "CompanyName": `${this.state.searchCompanyName}`,
                "TypologyName": `${this.state.TypologyName}`,
                "ExcludeTypologyName": this.state.ExcludeTypologyName,
                "companyStatusList": this.state.status,
                "isDeleted": this.state.isDeleted,
                "includeSoftDeleted": this.state.isDeleted,
                "HrNameSurname": this.state.hrFullName,
                "page": 1,
                "CityId": this.state.cityId,
                "ZipCodeId": this.state.zipCodeId,
                "PageSize": this.state.pageSize,
                "ordering": {
                    "orderPropertyName": this.state.orderBy,
                    "order": this.state.order
                }
            })
        }).then(response => response.json())
            .then(res => {



                this.setState({
                    totalItems: res.data.totalItems,
                    totalCompanies: res.data.totalCompanies,
                    totalBrands: res.data.totalBrands,
                    totalSigns: res.data.totalSigns,
                    totalDepartments: res.data.totalDepartments
                })
            })
    }

    searchCities(value) {
        //cerca le città partendo dal nome
        this.setState({ cityResult: value })
        if (value.length >= 3 || value.length === 0) {
            //City
            fetch(
                `${SERVER_URL + 'api/city/list'}`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${this.state.user}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    "name": value,
                    "page": 1,
                    "totalPages": 0,
                    "totalItems": 0,
                    "pageSize": 10,
                    "pageSizeOptions": null,
                    "firstItemNumber": 0,
                    "lastItemNumber": 0,
                    "ordering": {
                        "orderPropertyName": "name",
                        "order": 1
                    },
                    "entityId": 0
                })
            }
            ).then(response => response.json())
                .then(res => {
                    if (res.data != null) {
                        let zip = []
                        res.data.map(o =>

                            zip.push({ city: o, br: o.brCityZipCodes[0] })
                        )
                        this.setState({ citiesArray: zip });
                    }
                })

            if (value.length == 0) {
                this.setState({ searchZip: false });
            }
        }
    }

    deleteAddressResult() {
        this.setState({ addressResult: null });
        this.props.parentCallbackZip(null, this.state.index);
        this.props.parentCallbackCity(null, this.state.index);
    }

    clearResult() {
        this.setState({ zipResult: null, cityResult: null, zipCodeId: null, cityId: null }, this.handleFilters)
    }

    clearResultZip() {
        this.setState({ zipResult: null, zipCodeId: null, })
    }

    clearResultCity() {
        this.setState({ cityResult: null, cityId: null })
    }


    //fine addresses

    changeLanguage(lang) {
        this.setState(prevState => ({
            language: lang
        }))
    }

    handleNameChange(event) {
        //cerca nuove categorie quando si scrive nell'input delle categorie
        this.setState({ searchName: event.target.value, inDesignXML: '', inDesignXMLIndex: '', });
        if (this.state.searchName != null) {
            if (this.state.searchName.length > 1) {
                fetch(
                    `${SERVER_URL + 'api/companycategory/list?lang=en'}`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${this.state.user}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        "name": `${event.target.value}`,
                        "page": 1,
                        "PageSize": 88,
                        "ordering": {
                            "orderPropertyName": "catName",
                            "order": 1
                        }
                    })
                }
                ).then(response => response.json())
                    .then(res => {
                        if (res.data != null) {
                            let categories = []
                            res.data.sort(function (a, b) {
                                if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
                                if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
                                return 0;
                            }).map(cat => {
                                if (cat.companyCategoryParentCatId == null) {
                                    categories.push(cat)
                                    res.data.map(son => {
                                        if (son.companyCategoryParentCatId == cat.catId) {
                                            categories.push(son)
                                        }
                                    })
                                } else {
                                    if (res.data.findIndex(data => data.catId == cat.companyCategoryParentCatId) == -1) {
                                        categories.push(cat)
                                    }
                                }
                            })

                            this.setState({ categories: categories, loading: false });
                        }
                        else {
                            this.setState({ loading: false, categories: [] });
                        }
                        if (this.state.categories.length === 1) {
                            this.state.categories.map(cat =>
                                this.handleCat(cat.name)
                            )
                        }
                    })

            }
        }
        if (event.target.value == 0 || event.target.value.length == 0 || event.target.value == null || event.target.value == '') {
            this.fetchCat()
        }
    }

    handleCat(key) {
        //cambia la categoria selezionata, e fa partire la ricerca
        document.getElementById("scrollableInner").scrollTop = 0;
        var catId = ''
        let categoriesSelected = []
        if (key === 'all') {
            key = ''
            catId = null
        } else {
            var index = this.state.categories.findIndex(cat => cat.name == key)

            catId = [this.state.categories[index].catId]

            categoriesSelected = [this.state.categories[index].catId]

            this.state.categories.map(cat => {
                if (cat.companyCategoryParentCatId == this.state.categories[index].catId) {
                    categoriesSelected.push(cat.catId)
                }
            })
        }

        this.setState({ companyCategoryName: key, loading: true, categoriesSelected: categoriesSelected, categoryId: catId }, () => { this.crossFetch() });
    }

    reloadCompanies(e) {
        //infinite scroll, segue i filtri già attivi
        const fondo = e.target.scrollHeight - e.target.scrollTop < e.target.clientHeight + 3;
        if (fondo && this.state.maxPageSize > this.state.pageNumber && this.state.companies != []) {
            let newPage = this.state.pageNumber + 1;

            this.setState({ loadingBelow: true, inDesignXML: '', inDesignXMLIndex: '' })

            //companies
            fetch(
                `${SERVER_URL + 'api/company/list?lang=en'}`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${this.state.user}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    "CompanyName": `${this.state.searchCompanyName}`,
                    "companyCatIdList": this.state.categoryId,
                    "CompanyNameStartWith": this.state.iniziale == null ? null : "[" + this.state.iniziale + "]%",
                    "ExcludeTypologyName": this.state.ExcludeTypologyName,
                    "TypologyName": `${this.state.TypologyName}`,
                    "companyStatusList": this.state.status,
                    "HrNameSurname": this.state.hrFullName,
                    "page": newPage,
                    "isDeleted": this.state.isDeleted,
                    "includeSoftDeleted": this.state.isDeleted,
                    "PageSize": this.state.pageSize,
                    "ordering": {
                        "orderPropertyName": 'name',
                        "order": 1
                    }
                })
            }
            ).then(response => response.json())
                .then(res => {
                    if (res.data != null) {
                        if (res.data[0].companyId !== this.state.companies[0].companyId) {
                            this.setState({
                                companies: this.state.companies.concat(res.data), pageNumber: newPage, loadingBelow: false
                            });

                        }
                        else {
                            this.setState({ loadingBelow: false });
                        }
                    }
                    else {
                        this.setState({ loadingBelow: false, companies: [] });
                    }
                })
        }
    }

    getDetail(companyId, isLink) {
        if (companyId != null) {
            this.setState({ hasDetail: false })
            //la get per aprire il dettaglio di una company
            if (isLink) {
                this.setState({ hasDetail: false, detailIsLink: isLink, loadingDetail: true })
                fetch(
                    `${SERVER_URL + 'api/company/' + companyId + '?lang=en'}`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${this.state.user}`,
                        'Content-Type': 'application/json'
                    },
                }
                ).then(response => response.json())
                    .then(res => {
                        let c = res.data

                        this.setState({ companyDetail: res.data, hasDetail: true, visible: true });

                    })
            }
            else {
                this.setState({ detailIsLink: isLink, nextDetail: 'undefined', previousDetail: 'undefined', loadingDetail: true })

                let arrayIndexer = []

                this.state.companies.map(comp => {
                    arrayIndexer.push(comp.companyId)
                })

                var index = arrayIndexer.indexOf(companyId)

                var maxLength = arrayIndexer.length

                var next = index + 1

                var previous = index - 1

                if (next < maxLength) {
                    this.setState({ nextDetail: this.state.companies[next].companyId })
                } else {
                    if (this.state.maxPageSize > this.state.pageNumber) {
                        let newPage = this.state.pageNumber + 1;

                        this.setState({ loadingBelow: true, inDesignXML: '', inDesignXMLIndex: '' })

                        //companies
                        fetch(
                            `${SERVER_URL + 'api/company/list?lang=en'}`, {
                            method: 'POST',
                            headers: {
                                'Authorization': `Bearer ${this.state.user}`,
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify({
                                "CompanyName": `${this.state.searchCompanyName}`,
                                "companyCatIdList": this.state.categoryId,
                                "CompanyNameStartWith": this.state.iniziale == null ? null : "[" + this.state.iniziale + "]%",
                                "ExcludeTypologyName": this.state.ExcludeTypologyName,
                                "TypologyName": `${this.state.TypologyName}`,
                                "companyStatusList": this.state.status,
                                "HrNameSurname": this.state.hrFullName,
                                "page": newPage,
                                "isDeleted": this.state.isDeleted,
                                "includeSoftDeleted": this.state.isDeleted,
                                "PageSize": this.state.pageSize,
                                "ordering": {
                                    "orderPropertyName": 'name',
                                    "order": 1
                                }
                            })
                        }
                        ).then(response => response.json())
                            .then(res => {
                                if (res.data != null) {
                                    if (res.data[0].companyId !== this.state.companies[0].companyId) {

                                        let companies = this.state.companies.concat(res.data)

                                        this.setState({
                                            companies: companies.concat(res.data), pageNumber: newPage, loadingBelow: false,
                                        }, this.setState({ nextDetail: companies[next].companyId }));

                                    }
                                    else {
                                        this.setState({ loadingBelow: false });
                                    }
                                }
                                else {
                                    this.setState({ loadingBelow: false, companies: [] });
                                }
                            })
                    }
                }

                if (previous >= 0) {
                    this.setState({ previousDetail: this.state.companies[previous].companyId })
                }

                fetch(
                    `${SERVER_URL + 'api/company/' + companyId + '?lang=en'}`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${this.state.user}`,
                        'Content-Type': 'application/json'
                    },
                }
                ).then(response => response.json())
                    .then(res => {
                        this.setState({ companyDetail: res.data, hasDetail: true, visible: true });

                    })
            }
        }
    }

    searchCompany(event) {
        //alla ricerca della company, assegna lo stato e fa partire la ricerca
        document.getElementById("scrollableInner").scrollTop = 0;
        this.setState({ searchCompanyName: event.target.value });
    }

    handleTyp(value) {
        //cambia la tipologia, assegna lo stato
        if (value != undefined) {
            if (value === "Department") {
                this.setState({ TypologyName: value, ExcludeTypologyName: '' })
            }
            else {
                this.setState({ TypologyName: value, ExcludeTypologyName: 'Department' })
            }
        } else {
            this.setState({ TypologyName: '' })
        }
    }

    handleDeleted(value) {
        //assegna lo stato per controllare le companies deleted
        if (value) {
            this.setState({ compDeleted: value, isDeleted: 1, ExcludeTypologyName: '', status: [0, 1, 2, 3, 4, 5] })
        } else {
            this.setState({ compDeleted: value, isDeleted: null, ExcludeTypologyName: 'Department' })
        }
    }

    handleHidden(value) {
        //assegna lo stato per controllare le companies hidden
        var status = [5, 1, 0, 4, 3]
        if (value) {
            status = [0]
        }
        this.setState({ compHidden: value, status: status, compDisabled: false })
    }

    handleDisabled(value) {
        //assegna lo stato per controllare le companies disabled
        var status = [5, 1, 0, 4, 3]
        if (value) {
            status = [2]
        }
        this.setState({ compDisabled: value, status: status, compHidden: false })
    }

    handleBookmark(value) {
        //assegna lo stato per controllare le companies segnate come bookmark
        this.setState({ showOnlyBookmarked: value })
    }

    handleHrFullname(e) {
        //assegna lo stato per controllare le companies che contengono un hr con questo nome
        this.setState({ hrFullName: e.target.value })
    }

    clearFilters() {
        //svuota i filtri
        this.setState({ totalItems: null, showOnlyBookmarked: false, compHidden: false, compDisabled: false, status: [5, 1, 0, 4, 3], hrFullName: '', TypologyName: '', compDeleted: false, isDeleted: null, zipCodeId: null, cityId: null }, this.handleFilters)
        this.clearResult()
    }

    handleFilters() {
        // fa prtire la ricerca, dopo aver selezionato i vari filtri
        document.getElementById("scrollableInner").scrollTop = 0;

        if (this.state.showOnlyBookmarked || this.state.compHidden || this.state.compDisabled || this.state.hrFullName !== '' || this.state.TypologyName !== '' || this.state.compDeleted || this.state.zipCodeId != null || this.state.cityId != null) {
            this.setState({ hasFiltersOn: true, companies: [], loading: true }, () => { this.crossFetch() })
        }
        else {
            this.setState({ hasFiltersOn: false, companies: [], loading: true }, () => { this.crossFetch() })
        }
    }

    exportInDesign() {
        // fa partire la richiesta per l'xml
        this.setState({ loadingXML: true });

        if (this.state.companyCategoryName === '' && this.state.iniziale == null) {

            var status = 5
            if (this.state.compHidden) {
                status = 0
            }

            fetch(
                `${SERVER_URL + 'api/export?lang=en'}`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/xml',
                    'content-type': 'application/json',
                    'Authorization': `Bearer ${this.state.user}`,
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Headers': 'Content-Type',
                },
                body: JSON.stringify({
                    "companyName": "",
                    "companyNameStartsWith": "[]%",
                    "companyStatus": status
                })
            }
            ).then(response => response.text())
                .then(response => {
                    this.setState({ inDesignXML: response, loadingXML: false });
                })
        }
        else {
            var status = 5
            if (this.state.compHidden) {
                status = 0
            }

            fetch(
                `${SERVER_URL + 'api/export?lang=en&categoryName=' + this.state.companyCategoryName}`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/xml',
                    'content-type': 'application/json',
                    'Authorization': `Bearer ${this.state.user}`,
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Headers': 'Content-Type'
                },
                body: JSON.stringify({
                    "companyName": this.state.searchCompanyName,
                    "CompanyNameStartWith": this.state.iniziale == null ? null : "[" + this.state.iniziale + "]%",
                    "companyStatus": status
                })
            }
            ).then(response => response.text())
                .then(response => {
                    this.setState({ inDesignXML: response, loadingXML: false });
                })
        }
    }

    exportInDesignIndex() {
        // fa partire la richiesta per l'xml
        this.setState({ loadingXMLIndex: true });

        if (this.state.companyCategoryName === '' && this.state.iniziale == null) {

            var status = 5
            if (this.state.compHidden) {
                status = 0
            }

            fetch(
                `${SERVER_URL + 'api/export/companyIndex?lang=en&categoryName=' + this.state.companyCategoryName}`, {
                method: 'POST',
                headers: {
                    'content-type': 'application/json',
                    'Authorization': `Bearer ${this.state.user}`
                },
                body: JSON.stringify({
                    "companyName": "",
                    "companyNameStartsWith": "[]%",
                    "companyStatus": status
                })
            }
            ).then(response => response.text())
                .then(response => {
                    this.setState({ inDesignXMLIndex: response, loadingXMLIndex: false });
                })

        }
        else {
            var status = 5
            if (this.state.compHidden) {
                status = 0
            }

            fetch(
                `${SERVER_URL + 'api/export/companyIndex?lang=en&categoryName=' + this.state.companyCategoryName}`, {
                method: 'POST',
                headers: {
                    'content-type': 'application/json',
                    'Authorization': `Bearer ${this.state.user}`
                },
                body: JSON.stringify({
                    "companyName": this.state.searchCompanyName,
                    "CompanyNameStartWith": this.state.iniziale == null ? null : "[" + this.state.iniziale + "]%",
                    "companyStatus": status
                })
            }
            ).then(response => response.text())
                .then(response => {
                    this.setState({ inDesignXMLIndex: response, loadingXMLIndex: false });
                })
        }
    }

    copyToClipboard() {
        // converti da xml a file xml
        var date = new Date().getDate(); //Current Date
        var month = new Date().getMonth() + 1; //Current Month
        var year = new Date().getFullYear(); //Current Year
        var hours = new Date().getHours(); //Current Hours
        var min = new Date().getMinutes(); //Current Minutes

        var oggi = year + '' + month + '' + date + '_' + hours + '' + min

        var cat = this.state.companyCategoryName

        if (cat === '') {
            cat = 'AllCat'
        }

        var iniziale = this.state.iniziale

        if (iniziale == null) {
            iniziale = 'All'
        }

        const element = document.createElement("a");
        const file = new Blob([this.state.inDesignXML], { type: 'application/xhtml+xml' });
        element.href = URL.createObjectURL(file);
        element.download = "Polar_export_Catalogo_" + cat + "-" + iniziale + "_" + oggi + ".xml";
        document.body.appendChild(element); // Required for this to work in FireFox
        element.click();
    }

    copyToClipboardIndex() {
        // converti da xml a file xml
        var date = new Date().getDate(); //Current Date
        var month = new Date().getMonth() + 1; //Current Month
        var year = new Date().getFullYear(); //Current Year
        var hours = new Date().getHours(); //Current Hours
        var min = new Date().getMinutes(); //Current Minutes

        var oggi = year + '' + month + '' + date + '_' + hours + '' + min

        var cat = this.state.companyCategoryName

        if (cat === '') {
            cat = 'AllCat'
        }

        var iniziale = this.state.iniziale

        if (iniziale == null) {
            iniziale = 'All'
        }

        const element = document.createElement("a");
        const file = new Blob([this.state.inDesignXMLIndex], { type: 'application/xhtml+xml' });
        element.href = URL.createObjectURL(file);
        element.download = "Polar_export_Indice_Companies_" + cat + "-" + iniziale + "_" + oggi + ".xml";
        document.body.appendChild(element); // Required for this to work in FireFox
        element.click();
    }

    hide = () => {
        //nasconde il menù dei filtri
        this.setState({
            filterMenuVisible: false,
        });
    };

    handleVisibleChange = filterMenuVisible => {
        // mostra il menù dei filtri
        this.setState({ filterMenuVisible });
    };

    handleVisibleCount = hasCounterOn => {
        this.setState({ hasCounterOn });
    };

    render() {
        let compagnie = this.state.loading ? <Spin className="preloader" indicator={antIcon} /> :
            this.state.companies.map((comp, i) => {

                let hiddenOrNot = comp.status !== 0 ? '1' : '.7'

                return (
                    <Col xs="12" sm="6" md="4" xl="3" className={"cardComp visible"} style={{ opacity: hiddenOrNot }} key={i}>
                        <CardLite crossFetch={this.crossFetch} getDetail={this.getDetail} token={this.state.user} company={comp} />
                    </Col>
                )
            }
            );

        let listatyp = this.state.tipologies.map(tip =>
            <Option key={tip.text}>{tip.text}</Option>
        )

        let listZipCodes = this.state.zipCodesArray.map(zip => {
            let regionNan = zip.city.city.province.region.name == "§N.A.§" ? "N/A" : zip.city.city.province.region.name
            let provinceNan = zip.city.city.province.name == "§N.A.§" ? "N/A" : zip.city.city.province.name
            return (
                <Option key={zip.city.cityId} value={`${zip.city.zipCodeId}/${zip.city.cityId}$${zip.obj.value}, ${zip.city.city.name} (${provinceNan}) ${regionNan}`}>{zip.obj.value + ", " + zip.city.city.name + " (" + provinceNan + ") " + regionNan}</Option>
            )
        })

        let listCities = this.state.citiesArray.map(obj => {
            let regionNan = obj.city.province.region.name == "§N.A.§" ? "N/A" : obj.city.province.region.name
            let provinceNan = obj.city.province.name == "§N.A.§" ? "N/A" : obj.city.province.name
            return (
                <Option key={obj.br.zipCode.value} value={`${obj.br.zipCodeId}/${obj.city.cityId}$${obj.br.zipCode.value}, ${obj.city.name} (${provinceNan}) ${regionNan}`}>{obj.city.name + " (" + provinceNan + ") " + regionNan}</Option>
            )
        })

        let count = this.state.totalItems == null ?
            <Button onClick={this.getCount}>Load Count</Button>
            :
            <div className="asideBread">
                <span className="asideBreadTip">Companies: <b>{this.state.totalCompanies}</b></span><br />
                <span className="asideBreadTip">Brands: <b>{this.state.totalBrands}</b></span><br />
                <span className="asideBreadTip">Signs: <b>{this.state.totalSigns}</b></span><br />
                <span className="asideBreadTip">Departments: <b>{this.state.totalDepartments}</b></span>
            </div>

        let countFilter = <div>
            <div className="filterGroup" style={{ borderBottom: '0px solid', marginBottom: '0px', marginTop: '10px', }}>
                <div style={{ width: '100%', display: 'inline-flex' }}>
                    {count}
                </div>
            </div>
        </div>

        let filtri =
            <div>
                <div className="filterGroup">
                    <div style={{ width: '100%', display: 'inline-flex' }}>
                        <div style={{ width: '48%' }}>
                            <div className="filterGroupBlock">
                                <div style={{ display: 'block', width: '60%' }}>
                                    <span>Only deleted</span>
                                </div>
                                <div style={{ display: 'block', width: '40%' }}>
                                    <Switch defaultunchecked="true" checked={this.state.compDeleted} onChange={this.handleDeleted} style={{ display: 'block', margin: '0px 0px 0px auto' }} />
                                </div>
                            </div>
                        </div>

                        <div style={{ width: '48%', marginLeft: '4%' }}>
                            <div className="filterGroupBlock">
                                <div style={{ display: 'block', width: '60%' }}>
                                    <span>Only hidden</span>
                                </div>
                                <div style={{ display: 'block', width: '40%' }}>
                                    <Switch defaultunchecked="true" checked={this.state.compHidden} onChange={this.handleHidden} style={{ display: 'block', margin: '0px 0px 0px auto' }} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style={{ width: '100%', display: 'inline-flex' }}>
                        <div style={{ width: '48%' }}>
                            <div className="filterGroupBlock">
                                <div style={{ display: 'block', width: '60%' }}>
                                    <span>Only disabled</span>
                                </div>

                                <div style={{ display: 'block', width: '40%' }}>
                                    <Switch defaultunchecked="true" checked={this.state.compDisabled} onChange={this.handleDisabled} style={{ display: 'block', margin: '0px 0px 0px auto' }} />
                                </div>
                            </div>
                        </div>

                        <div style={{ width: '48%', marginLeft: '4%' }}>
                            <div className="filterGroupBlock">
                                <div style={{ display: 'block', width: '60%' }}>
                                    <span>Only bookmarked</span>
                                </div>
                                <div style={{ display: 'block', width: '40%' }}>
                                    <Switch defaultunchecked="true" checked={this.state.showOnlyBookmarked} onChange={this.handleBookmark} style={{ display: 'block', margin: '0px 0px 0px auto' }} />
                                </div>
                            </div>
                        </div>
                    </div>

                    <hr />

                    <div>

                        <div style={{ display: 'block', width: '100%' }}>

                            <p>Hr Name/Surname</p>
                        </div>
                        <div style={{ display: 'block', width: '100%' }}>
                            <Input autoComplete="new-password" value={this.state.hrFullName} style={{ display: 'block', margin: '0px 0px 0px auto' }} placeholder="Start typing to filter through companies" allowClear={true} onChange={this.handleHrFullname} />
                        </div>
                    </div>

                    <hr />

                    <div>
                        <div style={{ display: 'block', width: '100%' }}>

                            <p>Filter Typologies</p>
                        </div>
                        <div style={{ display: 'block', width: '100%' }}>
                            <Select
                                mode="single"
                                className={'selectWizard darkSelect handleTyp'}
                                placeholder="Typology"
                                style={{ width: '100%', fontWeight: '500' }}
                                onChange={this.handleTyp}
                                allowClear={true}
                                value={this.state.TypologyName}
                            >
                                {listatyp}
                            </Select>
                        </div>
                    </div>

                    <hr />

                    <div>
                        <div style={{ display: 'block', width: '100%' }}>
                            <p>Filter Caps</p>
                        </div>

                        <div style={{ display: 'inline-flex', width: '100%', marginBottom: '20px' }}>
                            <div style={{ width: 'calc(100% - 30px)' }}>
                                <AutoComplete
                                    style={{ width: '100%' }}
                                    dataSource={listZipCodes}
                                    value={this.state.zipResult}
                                    onSelect={this.handleZipCode}
                                    onSearch={this.searchZipCodes}
                                    onChange={this.handleResult}
                                    placeholder="ZipCode"
                                    dropdownMenuStyle={{ width: '300px', backgroundColor: 'white' }}
                                />

                            </div>
                            <div style={{ marginLeft: '15px' }}>
                                <Icon style={{ top: '4px', fontSize: '17px' }} onClick={this.clearResult} type="close-circle" />
                            </div>
                        </div>

                        <div style={{ display: 'inline-flex', width: '100%' }}>
                            <div style={{ width: 'calc(100% - 30px)' }}>
                                <AutoComplete
                                    style={{ width: '100%' }}
                                    dataSource={listCities}
                                    value={this.state.cityResult}
                                    onSelect={this.handleCities}
                                    onSearch={this.searchCities}
                                    onChange={this.handleResult}
                                    placeholder="City Name"
                                />
                            </div>
                            <div style={{ marginLeft: '15px' }}>
                                <Icon style={{ top: '4px', fontSize: '17px' }} onClick={this.clearResult} type="close-circle" />
                            </div>
                        </div>
                    </div>

                    <hr />

                    <div style={{ margin: '0px auto', display: 'block', width: 'fit-content' }}>
                        <a onClick={this.hide}><Button onClick={this.handleFilters} style={{ marginLeft: '0px' }}>Apply</Button></a>
                        <Button onClick={this.clearFilters} style={{ marginLeft: '16px' }}>Clear Filters</Button>
                    </div>
                </div>
            </div>

        let exportWait = this.state.loadingXML ? <Spin style={{ marginLeft: '20px' }} indicator={<Icon type="loading" style={{ fontSize: 24 }} spin />} /> : ''
        let exportWaitIndex = this.state.loadingXMLIndex ? <Spin style={{ marginLeft: '20px' }} indicator={<Icon type="loading" style={{ fontSize: 24 }} spin />} /> : ''

        let inDesign = this.state.inDesignXML !== '' ? <Button style={{ marginLeft: '11px', width: '125px' }} onClick={this.copyToClipboard}>Download File</Button> : <Button onClick={this.exportInDesign} style={{ marginLeft: '11px', width: '125px' }} size="default">Export Catalog</Button>
        let inDesignIndex = this.state.inDesignXMLIndex !== '' ? <Button style={{ marginLeft: '11px', width: '125px' }} onClick={this.copyToClipboardIndex}>Download File</Button> : <Button onClick={this.exportInDesignIndex} style={{ marginLeft: '11px', width: '125px' }} size="default">Export Index</Button>

        let popoverExport =
            <div>
                <div>
                    {inDesign}
                    {exportWait}
                </div>
                <div style={{ marginTop: '15px' }}>
                    {inDesignIndex}
                    {exportWaitIndex}
                </div>
            </div>

        let isDetailOff = this.state.loadingDetail ? '' :
            <Row className="justify-content-center pageSizeContainer">
                <Radio.Group value={this.state.pageSize} className="pageSize" onChange={this.handleSizeChange}>
                    <Radio.Button value={20}>20</Radio.Button>
                    <Radio.Button value={40}>40</Radio.Button>
                    <Radio.Button value={60}>60</Radio.Button>
                </Radio.Group>
            </Row>

        let detail = !this.state.hasDetail ?
            ''
            :
            this.state.fakeMap.map(fun => {
                let comp = this.state.companyDetail
                let isItLink = !this.state.detailIsLink ? <div className="navigationModal" ><Icon className={"left " + this.state.previousDetail} type="left" onClick={() => this.getDetail(this.state.previousDetail, false)} /><Icon className={"right " + this.state.nextDetail} type="right" onClick={() => this.getDetail(this.state.nextDetail, false)} /></div> : <div className="navigationModal" ></div>

                return (
                    <Modal
                        key={comp.companyId}
                        title={comp.name}
                        onCancel={() => this.setState({ visible: false, loadingDetail: false, modalDelete: false })}
                        visible={this.state.visible}
                        footer={null}
                    >
                        {isItLink}
                        <CardDetailed crossFetch={this.crossFetch} getDetail={this.getDetail} token={this.state.user} company={comp} />
                    </Modal>
                )
            }
            );

        let noComp = this.state.companies.length == 0 && !this.state.compLoad ?
            <div className="noComp">
                <h3>No Companies found</h3>
            </div> : ''

        let noCat = this.state.categories.length == 0 && !this.state.catLoad ?
            <div className="noCat">
                <b>No Categories found</b>
            </div> : ''

        let detailUp = this.state.loadingDetail ? <div className="sfondoDetail"></div> : ''

        //let easter = this.state.searchCompanyName === 'Isotta Fraschini' ? '-600px' : '110vw'
        //let easter2 = this.state.searchCompanyName === 'Isotta Fraschini' ? 'all 4s' : 'all 0s'
        let infiniteScroll = this.state.loadingBelow ? <Spin className="preloaderBelow" indicator={antIcon} /> : ''

        let collapsedOrNot = this.state.collapsed ? 'calc(100vw - 80px)' : 'calc(100vw - 160px)'

        let titolone = this.state.compDeleted ? 'Bin' : 'Companies'

        let allSelected = this.state.categoriesSelected.includes(0) || this.state.categoriesSelected.length == 0 ? 'ant-tabs-tab-active' : ''

        let plusIcon = !this.state.compDeleted ?
            <div className="plusButtonCat">
                <a style={{ marginRight: '10px' }} className="button create" href="/create" ><Icon type="plus" /></a>
            </div> : null

        let marBot = this.state.compDeleted ? "marginTopBin" : "marginTopNoBin"

        let clearSearchCat = this.state.searchName != undefined ? this.state.searchName != ' ' ? <Button className="clearCatSearch" onClick={this.refreshCatSearch} icon="close-circle"></Button> : null : null

        let searchForCatPlaceHolder = this.state.searchName == ' ' || this.state.searchName == null || this.state.searchName == '' ? <h3 className="searchForCatPlaceHolder">Filter through categories</h3> : null

        return (
            <Container className={"loading" + this.state.loading} onKeyUp={this.changeFocus} fluid={true}>
                {detailUp}
                <Row style={{ width: collapsedOrNot }}>
                    <Col sm="12" className={marBot}>
                        <Breadcrumb className="bread">
                            <Breadcrumb.Item>
                                {titolone}
                            </Breadcrumb.Item>
                        </Breadcrumb>
                        {plusIcon}

                        <div className="ant-breadcrumb searchList cat midSearchBar">
                            <Input autoComplete="new-password" style={{ width: '100%', marginTop: '-1em' }} onPressEnter={this.handleFilters} placeholder="Start typing to filter through companies" allowClear={true} value={this.state.searchCompanyName} onChange={this.searchCompany} />
                            <Icon className="homeViewSearch" onClick={this.handleFilters} type="search" />
                        </div>
                        <div className="ant-breadcrumb searchList filterButtons">
                            <div className="homeFilersButtonsContainer">
                                <Popover placement="bottomRight" title={<p>Filtered count</p>} onVisibleChange={this.handleVisibleCount} content={countFilter} trigger="click">
                                    <Avatar className={"calculatorIcon filterButton icon1pxRight filterson" + this.state.hasCounterOn} icon="calculator" />
                                </Popover>

                                <Popover placement="bottom" title={<p>Advanced filters</p>} content={filtri} visible={this.state.filterMenuVisible} onVisibleChange={this.handleVisibleChange} trigger="click">
                                    <Avatar style={{ margin: '0 10px' }} className={"filterButton filterson" + this.state.hasFiltersOn} icon="filter" />
                                </Popover>

                                <Popover placement="bottomLeft" title={<p>Export Results <br /><span style={{fontWeight: 200}}>Full export may take several minutes</span></p>} content={popoverExport} trigger="click">
                                    <Button className="exportButton" type="primary" shape="round" icon="download" size="default">
                                        Export
                                    </Button>
                                </Popover>
                            </div>
                        </div>
                    </Col>
                    <Col sm="12">
                        <Container style={{ padding: '0' }} fluid={true}>
                            <Row>
                                <Col sm='2' className="siderList">
                                    <div className="searchList cat">
                                        <Input autoComplete="new-password" placeholder="Filter categories" allowClear value={this.state.searchName} style={{ width: '100%' }} onChange={this.handleNameChange} />
                                    </div>

                                    <div className="ant-tabs catListStyle">
                                        <div className="ant-tabs-bar ant-tabs-left-bar ant-tabs-small-bar">
                                            <div className="yesCat ant-tabs-nav">
                                                <div onClick={() => this.handleCat('all')} className={"ant-tabs-tab " + allSelected} style={{ width: '100%' }} key="all">
                                                    <p className="relativenull">All</p>
                                                </div>

                                                {this.state.categories.map(cat => {
                                                    let isSelected = this.state.categoriesSelected.includes(cat.catId) ? 'ant-tabs-tab-active' : ''
                                                    if (cat.name.length > 20) {
                                                        return (
                                                            <div onClick={() => this.handleCat(cat.name)} style={{ width: '100%' }} className={"ant-tabs-tab " + isSelected} key={cat.name}>
                                                                <Popover content={cat.name} placement="right"><p className={"relative" + cat.companyCategoryParentCatId}>{cat.name}</p></Popover>
                                                            </div>
                                                        )
                                                    }
                                                    else {
                                                        return (
                                                            <div onClick={() => this.handleCat(cat.name)} style={{ width: '100%' }} className={"ant-tabs-tab " + isSelected} key={cat.name}>
                                                                <p className={"relative" + cat.companyCategoryParentCatId}>{cat.name}</p>
                                                            </div>
                                                        )
                                                    }
                                                })}
                                            </div>
                                        </div>
                                    </div>

                                    {noCat}
                                </Col>

                                <Col sm='10' style={{ paddingRight: '0px' }}>
                                    <Tabs id="lettere" onChange={this.callback} size="default" defaultActiveKey="a" tabPosition="top" >
                                        <TabPane tab="All" key="all">
                                        </TabPane>
                                        {this.state.alfabeto.map(i => (
                                            <TabPane tab={i} key={i}>
                                            </TabPane>
                                        ))}
                                    </Tabs>

                                    <Container onScroll={this.reloadCompanies} id="scrollableInner" className="innerTab" fluid={true}>
                                        <Row>
                                            {noComp}
                                            {compagnie}
                                            {detail}
                                            {infiniteScroll}
                                        </Row>
                                    </Container>
                                </Col>
                            </Row>
                        </Container>
                    </Col>
                </Row>
            </Container>
        );
    }
}


// WEBPACK FOOTER //
// ./src/Home/HomeIndexGET.js